import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const Location = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDyCtLgVFmT4WecAhz5h0waAGHDUIo7qKQ",
  });
  if (!isLoaded) return <div>Failed</div>;
  const onLoadMarker = (Marker) => {};

  return (
    <div className="w-full">
      <GoogleMap
        zoom={8}
        center={{ lat: 22.17554765166547, lng: 83.78757717457 }}
        mapContainerClassName="h-screen rounded-md "
      >
        <Marker
          className="w-96 h-96"
          onLoad={onLoadMarker}
          position={{ lat: 23.3431892, lng: 85.2512857 }}
        />
      </GoogleMap>
    </div>
  );
};

export default Location;
